// Inbox tabs controller - registers keyboard shortcuts to switch between
// Active and Snoozed tabs.
//
// Mount on the <nav> element containing the tab links.
//
// Targets:
//   tab - each tab link element
//
// Shortcut keys:
//   1 - Switch to Active tab
//   2 - Switch to Snoozed tab

import { Controller } from "@hotwired/stimulus"

const TAB_SHORTCUTS = Object.freeze([
  { key: "1", index: 0, description: "Active tab" },
  { key: "2", index: 1, description: "Snoozed tab" },
])

export default class extends Controller {
  static targets = ["tab"]

  connect() {
    this.registerShortcuts()
  }

  disconnect() {
    this.deregisterShortcuts()
  }

  // Private

  registerShortcuts() {
    this.registeredKeys = TAB_SHORTCUTS.map(s => s.key)

    TAB_SHORTCUTS.forEach(({ key, index, description }) => {
      document.body.dispatchEvent(
        new CustomEvent("shortcut:register", {
          detail: {
            key,
            description,
            category: "Inbox",
            handler: () => this.switchTab(index),
          },
          bubbles: true,
        })
      )
    })
  }

  deregisterShortcuts() {
    (this.registeredKeys || []).forEach((key) => {
      document.body.dispatchEvent(
        new CustomEvent("shortcut:deregister", { detail: { key }, bubbles: true })
      )
    })
  }

  switchTab(index) {
    const tab = this.tabTargets[index]
    if (tab) tab.click()
  }
}
